import { atom, PrimitiveAtom } from 'jotai';
import { pendingQueue } from '~/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export const $UserInfoStore: PrimitiveAtom<any> = atom<any>({});
export const $UserPostStore: PrimitiveAtom<any> = atom<any>({});
export const $UserRelatedStore: PrimitiveAtom<any> = atom<any>({});
export const $UserExtraStore: PrimitiveAtom<any> = atom<any>({});

// UserInfo UserPost UserRelated UserExtra
export const $UserInfo = safeAtomFamily((userLinkName: string) =>
  atom(
    (get) => {
      const data = get($UserInfoStore)[userLinkName];
      if (!data) {
        console.log('>> get $UserInfo failed', userLinkName);
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, args: any) => {
      console.log('>>> set $UserInfo', userLinkName, args);
      const old = get($UserInfoStore);
      set($UserInfoStore, { ...old, [userLinkName]: args });
    },
  ),
);

export const $UserExtra = safeAtomFamily((userLinkName: string) =>
  atom(
    (get) => {
      const data = get($UserExtraStore)[userLinkName];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(resolve));
      }
      return data;
    },
    (get, set, args: any) => {
      const old = get($UserExtraStore);
      set($UserExtraStore, { ...old, [userLinkName]: args });
    },
  ),
);
